import React from "react";
import { EmailConfirmation } from "@components";
import { LoginPagesLayout } from "@features/login/LoginPagesLayout";

export const EmailConfirmationPage = () => {
  return (
    <LoginPagesLayout>
      <EmailConfirmation />
    </LoginPagesLayout>
  );
};
